/* I'm not really sure this is the right folder for this, so if you think this is in the wrong place, feel free to move it */

/* One year update. This is almost certainly not the spot for this, it should probably go under utils.
Not sure what refactoring I'd need to do to make it work, so I'll leave this as a future intern/onboarding task.
TODO: Move this to /utils */

/*
* Don't forget to add manual overrides in router.js
* @param {*} name this is the name field for a page in the CMS
* @param {*} old this is the old url that we are redirecting from
* @param {*} url this is where you want it to point to */
function UrlOverride (name, old, url) {
  this.name = name
  this.old = old
  this.url = url
}

var overrides = [
  new UrlOverride('COVID-19 resources', '/covid-19-resources', '/COVID'),
  new UrlOverride('get your guide', '/Guide21', '/get-your-guide'),
  new UrlOverride('get-your-guide', '/Guide21', '/get-your-guide'), // VBA and NBND names are diff, dont ask me why.
  new UrlOverride('get your guide', '/guide21', '/get-your-guide'),
  new UrlOverride('get-your-guide', '/guide21', '/get-your-guide'),
  new UrlOverride('VSTRS', '/VSTRS', '/vstrs'),
  new UrlOverride('contact us', '/connect', '/contact-us'),
  new UrlOverride('contact us', '/Connect', '/contact-us'),
  new UrlOverride('live healthy', '/Live-Healthy', '/live-healthy'),
  new UrlOverride('get your guide', '/guide', '/get-your-guide'),
  new UrlOverride('get your guide', '/information', '/get-your-guide'),
  new UrlOverride('get-your-guide', '/guide', '/get-your-guide'),
  new UrlOverride('get-your-guide', '/information', '/get-your-guide'),
  new UrlOverride('2023-plans', '/plans', '/2023-plans'),
  new UrlOverride('2023-plans', '/enrollnow', '/2023-plans'),
  new UrlOverride('2023-plans', '/enroll', '/2023-plans'),
  new UrlOverride('2023-plans', '/lastchance', '/2023-plans'),
  new UrlOverride('events', '/Events', '/events'),
  new UrlOverride('2024-plans', '/plans', '/2024-plans'),
  new UrlOverride('2024-plans', '/enrollnow', '/2024-plans'),
  new UrlOverride('2024-plans', '/enroll', '/2024-plans'),
  new UrlOverride('2024-plans', '/lastchance', '/2024-plans'),
  new UrlOverride('2025-plans', '/plans', '/2025-plans'),
  new UrlOverride('2025-plans', '/enrollnow', '/2025-plans'),
  new UrlOverride('2025-plans', '/enroll', '/2025-plans'),
  new UrlOverride('2025-plans', '/lastchance', '/2025-plans'),
  new UrlOverride('UVM-redirect', '/UVM/*', '/uvm/*')
]

/**
 * Target can either be the name from the CMS or the old url
 * @param {string} target
 */
export function hasUrlOverride (target) { // eslint-disable-line no-unused-vars
  var found = false
  overrides.forEach((element) => {
    if (element.name.valueOf() === target.valueOf() || element.old.valueOf() === target.valueOf()) {
      found = true
    } else if (processWildUrl(target, element)) {
      found = true
    }
  })
  return found
}

function processWildUrl (target, element) {
  const old = element.old.valueOf()
  const wild = '*'

  // Bail if this is not a wildcard URL
  if (!old.includes(wild)) {
    return undefined
  }

  // Clean the old URL.
  const base = old.replace(wild, '')

  // Bail if target does not match our base URL
  if (!target.includes(base)) {
    return undefined
  }

  const cleanUrl = target.replace(base, '')
  const newUrl = element.url.replace(wild, cleanUrl)
  return newUrl
}

export function getUrlOverride (target) { // eslint-disable-line no-unused-vars
  var url = 'url'
  overrides.forEach((element) => {
    if (element.name.valueOf() === target.valueOf() || element.old.valueOf() === target.valueOf()) {
      url = element.url
    } else if (processWildUrl(target, element)) {
      url = processWildUrl(target, element)
    }
  })
  return url
}
